var BrandclubEventType;
(function (BrandclubEventType) {
    BrandclubEventType["PageView"] = "PageView";
    BrandclubEventType["NavigateToRetailer"] = "NavigateToRetailer";
    BrandclubEventType["AddToCart"] = "AddToCart";
    BrandclubEventType["OrderSubmitted"] = "OrderSubmitted";
    BrandclubEventType["PurchaseConfirmed"] = "PurchaseConfirmed";
    BrandclubEventType["ViewCart"] = "ViewCart";
    BrandclubEventType["InitiateCheckout"] = "InitiateCheckout";
    BrandclubEventType["OrderConfirmation"] = "OrderConfirmation";
})(BrandclubEventType || (BrandclubEventType = {}));

export { BrandclubEventType };
//# sourceMappingURL=types.js.map
